export const ListQueryKey = 'fruits';
export const DetailQueryKey = 'fruit';

export const Urls = {
  selectUrl: '/fruit/list',
  updateUrl: '/fruit/update',
  deleteUrl: '/fruit/delete',
  createUrl: '/fruit/create',
  detailUrl: '/fruit/detail',
};
